let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kVC8b")).then(() => parcelRequire('fuz0W'));